import React from 'react';
import {useDispatch} from 'react-redux';
import {layoutActions} from '..';
import {IDialogProps} from '../types';

export function useOpenSubDialog<T>(
   id: string,
   data?: T,
   title?: string,
   content?: string,
   onClose?: IDialogProps['onClose']
) {
   const dispatch = useDispatch();

   return React.useCallback(() => {
      dispatch(
         layoutActions.openSubDialog({
            id,
            data,
            title,
            content,
            onClose,
         })
      );
   }, [dispatch, id, data, title, content]);
}
